export default {
  navHome: "Início",
  navProducts: "Produtos",
  navCases: "Casos de Aplicação",
  navAbout: "Sobre nós",
  deliverTo: "Entregar em:",
  langCurrencyLabel: "Português",
  localeLangTitle: "Definir idioma",
  localeLangDesc:
    "Selecione o seu idioma preferido. Pode atualizar esta definição a qualquer momento.",
  language: "Idioma",
  save: "Guardar",
  coreProducts: "Impulsionando a criação no mundo real.",
  coreProductsDesc:
    "Da ideia ao negócio �?a YONGYUAN oferece impressoras UV, impressoras de etiquetas cristal, impressoras cilíndricas de alta velocidade, impressoras DTF e DTG, transformando a criatividade em produtos, marcas e oportunidades.",
  scenariosTitle: "Soluções para cada cenário",
  scenariosDesc:
    "Quer esteja a construir uma marca, a desenvolver um negócio paralelo ou a seguir paixões criativas, a YONGYUAN oferece uma solução adaptada às suas necessidades.",
  scenarioStudio: "Estúdio",
  scenarioStudioDesc:
    "Personalização de alto valor, prototipagem em pequenas séries e construção de marca",
  scenarioRetail: "Retalho de marca",
  scenarioRetailDesc:
    "Aumentar o tempo de permanência e as receitas na loja",
  scenarioMarket: "Feira de rua",
  scenarioMarketDesc:
    "Personalização no local, venda de produtos acabados e rendimento extra",
  scenarioEnterprise: "Personalização empresarial",
  scenarioEnterpriseDesc:
    "Personalização em lote, merchandising de marca e presentes corporativos",
  scenarioEcommerce: "Venda em livestream",
  scenarioEcommerceDesc:
    "Amostras de produtos de sucesso, fornecimento flexível e lançamentos rápidos",
  scenarioStore: "Loja online",
  scenarioStoreDesc:
    "Personalização de loja, merchandising de sucesso e operações diferenciadas",
  scenarioFactory: "Produção fabril",
  scenarioFactoryDesc:
    "Fabrico em lote, produção estável e operações rentáveis",
  scenarioAdvertising: "Produção publicitária",
  scenarioAdvertisingDesc:
    "Sinalização, materiais de exposição e materiais para eventos",
  industries: "Aplicações industriais",
  industriesDesc:
    "Soluções de impressão a jato de tinta digital para impressão a cores em diversos setores.",
  applicationsTitle:
    "Desbloqueie aplicações versáteis de materiais e cores para necessidades quotidianas e comerciais.",
  applicationsDesc:
    "Os equipamentos de impressão UV YONGYUAN são concebidos para uma ampla gama de materiais e cenários de processo, permitindo personalização e produção em grande escala.",
  casesHeroDesc:
    "Mais de 1200 aplicações industriais e dezenas de milhares de materiais imprimíveis — soluções de impressão digital para diferentes negócios.",
  casesBreadcrumbHome: "Início",
  casesBreadcrumbCenter: "Casos de Aplicação",
  casesEmpty: "Ainda não há casos de aplicação nesta categoria.",
  customerStoriesTitle: "Confiado por clientes em todo o mundo",
  customerStoriesSubtitle:
    "Instalações reais, clientes reais, negócios de impressão reais em 172 países.",
  customerStoriesStat1Value: "53.000+",
  customerStoriesStat1Label: "Impressoras entregues",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Países atendidos",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Anos de experiência",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Suporte técnico",
  customerStoriesPlaceholder: "Adicionar foto do cliente",
  customerStoriesPhotoAlt: "Cliente YONGYUAN com impressora",
  servicePartnerTitle:
    "Conheça a equipa de serviço YONGYUAN, o seu parceiro criativo",
  servicePartnerDesc:
    "Uma rede de serviço global e sistema de suporte profissional para proteger o desempenho do seu equipamento e o crescimento do seu negócio.",
  serviceSupportTitle: "Suporte padrão",
  serviceSupportDesc:
    "Orientação de instalação, formação básica e assistência no uso diário para manter o equipamento a funcionar de forma fiável.",
  servicePresaleTitle: "Demonstração e consulta pré-venda",
  servicePresaleDesc:
    "Demonstrações de soluções e recomendações de modelos adaptadas aos seus cenários de aplicação e requisitos de capacidade.",
  serviceLifetimeTitle: "Suporte técnico vitalício",
  serviceLifetimeDesc:
    "Resposta técnica contínua e suporte de processos para acompanhar o seu desenvolvimento empresarial a longo prazo.",
  serviceCareTitle: "Atualize para YONGYUAN Care",
  serviceCareDamageTitle: "Proteção contra danos acidentais",
  serviceCareDamageDesc:
    "Um plano de proteção mais abrangente para reduzir perdas causadas por incidentes inesperados.",
  serviceCareExchangeTitle: "Serviço de troca rápida",
  serviceCareExchangeDesc:
    "Arranjos prioritários de troca rápida em condições elegíveis para acelerar a recuperação de capital.",
  viewProduct: "Ver produtos",
  learnMore: "Saber mais",
  catUv: "Impressora UV de mesa",
  catCylinder: "Impressora cilíndrica",
  catCrystal: "Impressora de etiqueta cristal",
  catDtf: "Impressora DTF",
  catDtg: "Impressora DTG",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Telefone: 17748697567 Gestor Tang",
  email: "E-mail: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Todos os direitos reservados",
  productsHeroTitle: "Produtos",
  productsHeroDesc:
    "Linha completa de equipamentos UV de mesa, cilíndricos, etiquetas cristal, DTF e DTG para diversas necessidades de capacidade e aplicação.",
  productsBreadcrumbHome: "Início",
  productsBreadcrumbCenter: "Produtos",
  productsEmpty: "Os produtos desta categoria estarão disponíveis em breve.",
  productsQuoteTitle: "Solicitar solução e orçamento",
  productsQuoteDesc:
    "Partilhe os seus cenários de aplicação e requisitos de capacidade, e recomendaremos a solução de equipamento adequada.",
  productsContact: "Contacte-nos",
  aboutHeroTitle: "Sobre a Yongyuan",
  aboutHeroDesc:
    "23 anos focados em I&D e produção de equipamentos de impressão UV",
  productA23Subtitle: "Impressora UV inteligente de 6 cores para secretária",
  productA23Feature1: "Formato de impressão A4",
  productA23Feature2: "Sistema inteligente de fornecimento de tinta",
  productA23Feature3: "Deteção automática de altura por infravermelhos",
  productA35Subtitle: "Impressora UV inteligente de 6 cores para secretária",
  productA35Feature1: "Formato de impressão A3+",
  productA35Feature2: "Sistema inteligente de fornecimento de tinta",
  productA35Feature3: "Deteção automática de altura por infravermelhos",
  productA43Subtitle: "Impressora UV inteligente de 8 cores topo de gama",
  productA43Feature1: "Formato de impressão A3",
  productA43Feature2: "Múltiplas configurações de cabeças de impressão",
  productA43Feature3: "Sistema inteligente de fornecimento de tinta",
  productA46Subtitle: "Impressora UV inteligente de 8 cores topo de gama",
  productA46Feature1: "Formato de impressão A2",
  productA46Feature2: "Múltiplas configurações de cabeças de impressão",
  productA46Feature3: "Sistema inteligente de fornecimento de tinta",
  productA57Subtitle: "Impressora UV inteligente de 8 cores topo de gama",
  productA57Feature1: "Formato de impressão A2+",
  productA57Feature2: "Múltiplas configurações de cabeças de impressão",
  productA57Feature3: "Sistema inteligente de fornecimento de tinta",
  productA69Subtitle: "Impressora UV inteligente de 8 cores topo de gama",
  productA69Feature1: "Formato de impressão A1",
  productA69Feature2: "Múltiplas configurações de cabeças de impressão",
  productA69Feature3: "Sistema inteligente de fornecimento de tinta",
  productA1216Subtitle: "Impressora UV de mesa grande formato topo de gama",
  productA1216Feature1: "Formato de impressão 1200×1600cm",
  productA1216Feature2: "Múltiplas configurações de cabeças de impressão",
  productA1216Feature3: "Sistema de posicionamento visual",
  productA2513Subtitle: "Impressora UV de mesa grande formato topo de gama",
  productA2513Feature1: "Formato de impressão 2500×1300cm",
  productA2513Feature2: "Múltiplas configurações de cabeças de impressão",
  productA2513Feature3: "Sistema de posicionamento visual",
  productCylinderElfSubtitle: "Impressora cilíndrica de alta velocidade 360°",
  productCylinderElfFeature1: "Impressão 360°",
  productCylinderElfFeature2: "Personalização de copos e garrafas",
  productCylinderElfFeature3: "Troca rápida de dispositivos",
  productCupPlusSubtitle: "Solução de impressão multi-tamanho para copos e garrafas",
  productCupPlusFeature1: "Dispositivos multi-tamanho",
  productCupPlusFeature2: "Alta eficiência de produção",
  productCupPlusFeature3: "Produção estável",
  productCrystal60Subtitle: "Sistema tudo-em-um de impressão e folheação de etiquetas cristal",
  productCrystal60Feature1: "Largura de 60cm",
  productCrystal60Feature2: "Integração de impressão e folheação",
  productCrystal60Feature3: "Sistema de recolha eficiente",
  productCrystalC60UltraFeature1: "Largura 60 cm",
  productCrystalC60UltraFeature2: "Opções ouro/prata/rótulo silicone 3D",
  productCrystalC60UltraFeature3: "Produção em massa",
  productCrystal30Subtitle: "Impressora compacta de alta precisão para etiquetas cristal",
  productCrystal30Feature1: "Impressão de precisão compacta",
  productCrystal30Feature2: "Operação fácil",
  productCrystal30Feature3: "Personalização individual",
  productDtf60Subtitle: "Impressora de transferência DTF com tinta branca",
  productDtf60Feature1: "Transferência DTF com tinta branca",
  productDtf60Feature2: "Camadas de cor ricas",
  productDtf60Feature3: "Acessórios de vestuário",
  productDtfF20Subtitle: "A mais compacta impressora DTF de tinta branca desktop do setor",
  productDtfF20Feature1: "Tamanho A4",
  productDtfF20Feature2: "Personalização em pequenas séries",
  productDtfF20Feature3: "Sistema inteligente de tinta",
  productDtfF30Subtitle: "Impressora DTF de tinta branca desktop",
  productDtfF30Feature1: "Tamanho A3",
  productDtfF30Feature2: "Cabeça única manual/automática opcional",
  productDtfF30Feature3: "Sistema inteligente de tinta",
  productDtfF30ProSubtitle: "Impressora DTF de tinta branca",
  productDtfF30ProFeature1: "Tamanho A3",
  productDtfF30ProFeature2: "Configuração de dois cabeçotes com recolhimento automático de filme",
  productDtfF30ProFeature3: "Sistema inteligente de tinta",
  productDtfF33Subtitle: "Impressora DTF de tinta branca",
  productDtfF33Feature1: "Tamanho A3",
  productDtfF33Feature2: "Cabeça única manual/automática opcional",
  productDtfF33Feature3: "Sistema inteligente de tinta",
  productDtfF70ProSubtitle: "Impressora DTF de tinta branca formato largo 70 cm",
  productDtfF70ProFeature1: "Tamanho A2",
  productDtfF70ProFeature2: "Opções de 2 a 4 cabeçotes",
  productDtfF70ProFeature3: "Sistema automático de alimentação e saída",
  productDtfF70ProFeature4: "Modo inteligente de retomada de impressão",
  productDtf30Subtitle: "Impressora DTF compacta com tinta branca",
  productDtf30Feature1: "Personalização em pequenas séries",
  productDtf30Feature2: "Reprodução de cor precisa",
  productDtf30Feature3: "Fácil de usar",
  productDtgPrintSubtitle: "Impressora digital direta em têxtil",
  productDtgPrintFeature1: "Impressão direta multi-material",
  productDtgPrintFeature2: "Alto rendimento",
  productDtgPrintFeature3: "Estável e durável",
  productDtg3250DSubtitle: "Único modelo 2 em 1 DTF e DTG do setor",
  productDtg3250DFeature1: "Formato A3+",
  productDtg3250DFeature2: "Impressão dual DTF e DTG",
  productDtg3250DFeature3: "Sistema inteligente de tinta",
  productDtg3646TSubtitle: "Impressora DTG de estação dupla",
  productDtg3646TFeature1: "Modo de produção contínua",
  productDtg3646TFeature2: "Aumento de 100% na produtividade",
  productDtg3646TFeature3: "Sistema inteligente de tinta",
  productDtgMaxSubtitle: "Impressora DTG digital industrial",
  productDtgMaxFeature1: "Capacidade industrial",
  productDtgMaxFeature2: "Estável e durável",
  productDtgMaxFeature3: "Operação contínua",
  app01Title: "Capas de telemóvel",
  app02Title: "Bolas de golfe",
  app03Title: "Placas de pedra",
  app04Title: "Canetas esferográficas",
  app05Title: "Estojos para óculos",
  app06Title: "Gravuras em madeira",
  app07Title: "Latas de bebidas",
  app08Title: "Teclados",
  app09Title: "Garrafas térmicas",
  app10Title: "Bagagem",
  app11Title: "Produtos em acrílico",
  app12Title: "Cadernos",
  app13Title: "Crachás",
  app14Title: "Porta-cartões em couro",
  app15Title: "Placas de identificação",
  app16Title: "Arte em vidro",
  appDtgCase01: "T-shirts",
  appDtgCase02: "Hoodies",
  regionCn: "China",
  regionUs: "Estados Unidos",
  regionGb: "Reino Unido",
  regionDe: "Alemanha",
  regionAe: "EAU",
  regionIn: "Índia",
  regionJp: "Japão",
  regionVn: "Vietname",
  regionBr: "Brasil",
  regionAu: "Austrália",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
